<mat-card>
  <mat-card-title
    ><span>{{ getTitle() }}</span>
    <button mat-icon-button (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button></mat-card-title
  >
  <mat-card-content>
    <div class="content__body">
      <div [ngClass]="data.isOtherRoom ? 'flex flex-col' : 'content__form'" [formGroup]="form">
        <mat-form-field mat-input-height-large-label class="flex-[100%] max-w-[100%]">
          <mat-label>{{ '+SRC_COMMISSIONINGV2.EDIT_ROOM_MODAL_TITLE' | translate }}</mat-label>
          <input
            gtm="onTextField"
            gtmAction="Room name"
            gtmCategory="Edit room modal"
            [gtmOn]="['change', 'focus', 'blur']"
            matInput
            data-at-room-name
            name="roomName"
            formControlName="roomName"
            [errorStateMatcher]="matcher"
            fieldTextContentTooltip
          />
          <mat-error
            data-at-edit-room-modal-error-not-unique-room
            *ngIf="form.controls.roomName.hasError('notUnique')"
          >
            {{ '+SRC_COMMISSIONINGV2.EDIT_ROOM_MODAL_ROOM_NOT_UNIQUE' | translate }}
          </mat-error>
          <mat-error
            data-at-edit-room-modal-error-too-long
            *ngIf="form.controls.roomName.hasError('maxlength')"
          >
            {{ '+SRC_COMMISSIONINGV2.EDIT_ROOM_MODAL_TOO_LONG_ROOM_NAME' | translate }}
          </mat-error>
          <mat-error
            data-at-edit-room-modal-error-not-valid
            *ngIf="
              form.controls.roomName.hasError('pattern') ||
              form.controls.roomName.hasError('consecutiveSpaces')
            "
          >
            {{ '+SRC_COMMISSIONINGV2.EDIT_ROOM_MODAL_NOT_VALID_ROOM_NAME' | translate }}
          </mat-error>
          <mat-error
            data-at-edit-room-modal-error-required
            *ngIf="form.controls.roomName.hasError('required')"
          >
            {{ '+SRC_COMMISSIONINGV2.EDIT_ROOM_MODAL_REQUIRED_ROOM_NAME' | translate }}
          </mat-error>
        </mat-form-field>
        <mat-form-field
          mat-select-height-large
          *ngIf="!data.isOtherRoom"
          class="search-dropdown flex-[100%] max-w-[100%]"
          data-at-room-type
        >
          <mat-label>{{
            '+INSTALLATIONS.INSTALLATION.COMMISSIONING.ROOM_TYPE' | translate
          }}</mat-label>
          <mat-select formControlName="roomType">
            <mat-option
              *ngFor="let type of roomTypeOptions"
              [value]="roomTypes[type]"
              gtm="onSelect"
              gtmAction="Room type"
              gtmCategory="editRoom"
              fieldTextContentTooltip
              >{{ '+INSTALLATIONS.INSTALLATION.SRC.ROOM.' + type | translate }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="!data.isOtherRoom" class="content__room-actions">
        <button
          mat-stroked-button
          gtm="onClick"
          gtmCategory="deleteRoom"
          color="primary"
          [disabled]="!(canDeleteRoom$ | async)"
          (click)="onDeleteRoom()"
        >
          {{ '+SRC_COMMISSIONINGV2.DELETE_ROOM_TITLE' | translate }}
        </button>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <button
      mat-stroked-button
      gtm="onCancelDialog"
      gtmAction="Close"
      gtmCategory="editRoomModal"
      color="primary"
      (click)="closeDialog()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      [disabled]="isConfirmButtonDisabled()"
      mat-raised-button
      gtm="onSave"
      gtmAction="Save"
      gtmCategory="editRoomModal"
      color="primary"
      (click)="onConfirm()"
    >
      {{ 'GENERAL.BUTTON.CONFIRM' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
